<template>
  <div class="container">
    <button
      type="button"
      data-role="none"
      class="slick-arrow slick-prev"
      :class="{ 'disabled': status === 0 }"
      style="display: block"
      @click="swiper.slidePrev()"
      v-if="showArrows"
    >
      Previous
    </button>

    <Swiper
      :modules="[Navigation, Pagination]"
      :slides-per-view="1"
      :loop="false"
      :navigation="false"
      :pagination="{
        clickable: true,
      }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <SwiperSlide v-for="(media, index) in postContent" :key="index">
        <div class="carousel-item">
          <PostSimple
            :postData="postData"
            :postContent="media"
            :model="model"
            :VideoElementHandler="VideoElementHandler"
            :index="index"
          />
        </div>
      </SwiperSlide>
    </Swiper>

    <button
      type="button"
      data-role="none"
      class="slick-arrow slick-next"
      :class="{ 'disabled': status === 1 }"
      style="display: block"
      @click="swiper.slideNext()"
      v-if="showArrows"
    >
      Next
    </button>
      
  </div>
</template>

<script setup lang="ts">
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { PostContent, PostData } from "~/types/Post";
import { Model } from "~/types/Model";

interface _Props {
  postData: PostData;
  postContent: PostContent;
  model: Model;
  VideoElementHandler: any;
}

const swiper = ref<any>(null);
const status = ref<number>(0);

const { postData, postContent, model, VideoElementHandler }: _Props =
  withDefaults(defineProps<_Props>(), {
    VideoElementHandler: {},
});

const onSwiper = (data: any) => {
  swiper.value = data;
};

const onSlideChange = (data: any) => {
  status.value = data.progress;
};

const showArrows = computed(() => window.innerWidth > 768);
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
</style>

<style lang="scss">
.slick-dots {
  position: unset;
}

@font-face {
  font-family: 'slick';
  src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAATsAA0AAAAAB2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAE0AAAABoAAAAcdIcYB0dERUYAAAS0AAAAHAAAAB4AJwANT1MvMgAAAZwAAABRAAAAYFAQ/45jbWFwAAACAAAAAFcAAAFiIhFFt2dhc3AAAASsAAAACAAAAAj//wADZ2x5ZgAAAmgAAAE1AAACLD+btmBoZWFkAAABMAAAAC8AAAA2AAEx+2hoZWEAAAFgAAAAHAAAACQD5QIFaG10eAAAAfAAAAAQAAAAFgZKAEpsb2NhAAACWAAAABAAAAAQATYBoG1heHAAAAF8AAAAHQAAACAASwBHbmFtZQAAA6AAAADcAAABbgUngcJwb3N0AAAEfAAAAC4AAABFOXjBpHjaY2BkYGAA4vMGfuHx/DZfGbiZGEDgfGFFPZxWZVBlvM14G8jlYABLAwAT1QnNAHjaY2BkYGC8zcDAoMfEAAJANiMDKmABADBkAe942mNgZGBgYGdwYWBiAAEQycgAEnMA8xkACcgAkwAAAHjaY2BmYmCcwMDKwMDow5jGwMDgDqW/MkgytDAwMDGwcjKAQQNQCZBSYICCgDTXFAYHhkTFSYwP/j9g0GO8/f82A0QNA+NtsBIFBkYANHMN4wAAAHjaY2KAACYIVoVAAALCAJt42mNgYGBmgGAZBkYGEIgB8hjBfBYGByDNw8DBwARkMzAkKigpTlCc9P8/WB0S7/+i+4/uld4rgZoAB4xsDHAhRiYgwcSApoCBcsBMBTNYGGgGAEdEDyUAAAAAAAAAAAAAZgCKANABFnjadZBdToNAEMd3CrtAl5TQLtS0LCoN0A8SGkBI+mAfPET75B1896HppfQcvnII4w3cLYpW6k4ymdn9z8xvBwEKUQg11OgBIXAYWUEQR1uIZoFGpLGxKy3PqrIq8+waXIfJ+5mQSSvkvXwRqqocu1D39QMl2JgvN9zzhsyk1GRDz+OBfzMioCqx0rtdLYo0SiZTZttsOkmidBkveKibFF4Oep9SI46bqk3Twhp4iihUemrMWFPy2NRbthfqKkHi/PxlJLITZdAiSj6ouZ+tn9eZz78DuD9LZYB6bZ8rlCAUVuVdkULjxV4sIEysIc/KSyPmnJDdjhCOdQ0fCTliTX/tjH3ysWao+71qaNjHQjcQwrcuyl+WLZQthCMotJP/h+Xjazz+hfTeRWmG4zOiSyif/q1OtAAAAHjabY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV42mNgYkAGjAzogB0sysTgwtDOyMTIzJlYVJRfnpOaVsIFZhVlpmeUAABuKQkSAAAAAAAB//8AAnjaY2BkYGDgAWIxIGZiYARCNiBmAfMYAAPgADV42mNgYGBkAIKrS9Q5QPT5wop6GA0APf8GGAAA)
    format('woff');
}

.slick-arrow {
  $SIZE: 30px;
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: $SIZE;
  height: $SIZE;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
  // background: transparent;
  // background-color: rgba($color: #000000, $alpha: 0.8);
  background-color: inherit;
  border-radius: 50%;
  z-index: 999;

  &:hover {
    color: transparent;
    outline: none;
    background: transparent;

    &::before {
      opacity: 1;
    }
  }

  &::before {
    font-size: 30px;
    font-family: 'slick';
    line-height: 1;
    opacity: 0.75;
    color: black;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    cursor: pointer;
  }

  &.disabled {
    &::before {
      opacity: 0.25;
    }
  }

  $DISTANCE: -35px;

  &.slick-prev {
    left: $DISTANCE;
    
    &::before {
      // margin-right: 3px;
      content: '\2190';
    }
  }

  &.slick-next {
    right: $DISTANCE;
    
    &::before {
      // margin-left: 2px;
      content: '\2192';
    }
  }
}

.carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // padding: 0 1rem;
}
</style>

<style lang="scss">
.swiper {
  width: 100%;
  height: 100%;

  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper {
  > .swiper-button-prev,
  > .swiper-button-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;

    &::before {
      font-family: "slick";
      font-size: 20px;
      line-height: 1;
      opacity: 0.75;
      color: white;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  > .swiper-button-prev {
    left: -25px;

    &::before {
      content: "\2190";
    }
  }

  > .swiper-button-next {
    right: -25px;

    &::before {
      content: "\2192";
    }
  }

  > .swiper-pagination {
    position: relative;
    position: unset;
    bottom: -25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;

    &.swiper-pagination-bullets {
      margin-block-start: 1em;
      margin-block-end: 1em;

      > .swiper-pagination-bullet {
        $SIZE: 10px;
        width: $SIZE;
        height: $SIZE;
        background: rgba(0, 0, 0, 0.25);
        opacity: 1;
        padding: 5px;
        margin-inline: 10px; // calc(10px - #{$SIZE} / 2 + 5px);
        position: relative;

        &::before {
          $SIZE: 25px;
          content: "";
          display: block;
          width: $SIZE;
          height: $SIZE;
          border-radius: 50%;
          background-color: transparent;
          clear: both;
          top: -50%;
          right: -50%;
          position: absolute;
        }

        &.swiper-pagination-bullet-active {
          background: var(--pallete_main_color) !important;
        }

        &:hover {
          background: black;
        }
      }
    }
  }
}

</style>
